// extracted by mini-css-extract-plugin
export default {"icon":"CopyButtonCell_icon__5prHN"};